import { ErrorMessage } from 'components'
import { useGetLocationPartners, useGetMenuImportStatuses } from 'hooks'
import { LocationSummary } from 'types'

import MenuImportShortcut from './MenuImportShortcut'
import PlatformShortcut from './PlatformShortcut'
import PrepTimeShortcut from './PrepTimeShortcut'
import * as Styled from './styles'

export type Platforms = {
  enabledPlatforms: LocationSummary['enabledPlatforms']
  disabledPlatforms: LocationSummary['disabledPlatforms']
  onboardingPlatforms?: LocationSummary['onboardingPlatforms']
}

type Props = {
  locationId: string
}

const Shortcut = ({
  locationId,
}: Props) => {
  const {
    partner,
    isError,
    platforms,
    menuMappingMenuId,
    refetch 
  } = useGetLocationPartners(locationId)
 
  const posName = partner?.attributes?.pos?.toLowerCase() || ''
  const isPrinterClient = posName.includes('epson') // We don't want to show printer clients the menu resync option

  const [{ menuImportStatuses, isLoading: isMenuStatusLoading }] = useGetMenuImportStatuses(
    locationId,
    1,
  )

  // Show shortcut for platforms that have pickup or delivery prep time configured
  const eligiblePlatform = platforms?.find(
    (p) => p.internalName === 'Custom' || p.internalName === 'GoogleFo',
  )
  
  return (
    <Styled.ShortcutContainer>
      {isError && <ErrorMessage />}
      {!isError && (
        <>
          <Styled.ShortcutsHeader>Shortcuts</Styled.ShortcutsHeader>
        
          {!isPrinterClient && (
            <MenuImportShortcut
              menuImportStatuses={menuImportStatuses}
              menuMappingMenuId={menuMappingMenuId}
              locationId={locationId}
              isMenuLoading={isMenuStatusLoading}
            />
          )}
          <PlatformShortcut platforms={platforms} refetch={refetch} />
          {eligiblePlatform && (
            <PrepTimeShortcut partner={partner} />
          )}
        </>
      )}
    </Styled.ShortcutContainer>
  )
}

export default Shortcut
